import {parseURL} from "./parseURL";
import UserRequest from "../types/Requests/UserRequest";
import UserRequestInterface from "../types/Requests/UserRequestInterface";

export function detectRequest(url: string): UserRequest | null {
    return new UserRequest(parseURL<UserRequestInterface>(url));
}
